export default "__VITE_ASSET__CTSlxmJQ__"